"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.getHotelOrderEndUserStatus = getHotelOrderEndUserStatus;
var _get2 = _interopRequireDefault(require("lodash/get"));
var _constants = require("../constants");
const {
  PENDING,
  AUTHORIZED,
  AUTHORIZED_WITH_INSTALLMENTS
} = _constants.PAYMENT_STATUS;
const {
  CANCELLED,
  FAILURE,
  SUCCESS
} = _constants.OLD_BOOKING_STATUS;

/**
 * get hotel order end user status
 * @param {Number} paymentStatus
 * @param {Number} bookingStatus
 * @param {Boolean} stayCompleted
 * @return {string}
 */
function getHotelOrderEndUserStatus({
  paymentStatus,
  bookingStatus,
  stayCompleted
}) {
  const endUserStatusMap = {
    [AUTHORIZED]: {
      [SUCCESS]: _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMED,
      [FAILURE]: _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMED,
      [CANCELLED]: _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_NOW
    },
    [AUTHORIZED_WITH_INSTALLMENTS]: {
      [SUCCESS]: _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMED,
      [FAILURE]: _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMED,
      [CANCELLED]: _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_NOW
    },
    [PENDING]: {
      [SUCCESS]: _constants.HOTEL_ORDER_END_USER_STATUS.PAYMENT_PENDING,
      [FAILURE]: _constants.HOTEL_ORDER_END_USER_STATUS.NOT_CONFIRMED,
      [CANCELLED]: _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_LATER
    }
  };
  const afterCheckinDateEndUserStatusMap = {
    [AUTHORIZED]: {
      [SUCCESS]: _constants.HOTEL_ORDER_END_USER_STATUS.STAY_COMPLETED,
      [FAILURE]: _constants.HOTEL_ORDER_END_USER_STATUS.STAY_COMPLETED,
      [CANCELLED]: _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_NOW
    },
    [AUTHORIZED_WITH_INSTALLMENTS]: {
      [SUCCESS]: _constants.HOTEL_ORDER_END_USER_STATUS.STAY_COMPLETED,
      [FAILURE]: _constants.HOTEL_ORDER_END_USER_STATUS.STAY_COMPLETED,
      [CANCELLED]: _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_NOW
    },
    [PENDING]: {
      [SUCCESS]: _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_LATER,
      [FAILURE]: _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_LATER,
      [CANCELLED]: _constants.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_LATER
    }
  };
  return stayCompleted ? (0, _get2.default)(afterCheckinDateEndUserStatusMap, `${paymentStatus}.${bookingStatus}`, _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMING_WITH_HOTEL) : (0, _get2.default)(endUserStatusMap, `${paymentStatus}.${bookingStatus}`, _constants.HOTEL_ORDER_END_USER_STATUS.CONFIRMING_WITH_HOTEL);
}